const key = 'VARIABLES__';

exports.VARIABLES_SET_GROUPS = `${key}SET_GROUPS`;
exports.VARIBLES_GROUPS_LOADING = `${key}GROUPS_LOADING`;
exports.VARIABLES_GROUPS_ERROR = `${key}GROUPS_ERROR`;
exports.VARIABLES_GROUPS_ADD = `${key}GROUPS_ADD`;

exports.VARIABLES_SET_BRANDS = `${key}SET_BRANDS`;
exports.VARIBLES_BRANDS_LOADING = `${key}BRANDS_LOADING`;
exports.VARIBLES_BRANDS_ERROR = `${key}BRANDS_ERROR`;

exports.VARIABLES_SET_DEFAULT_ALARMS = `${key}SET_DEFAULT_ALARMS`;
exports.VARIABLES_UPDATE_DEFAULT_ALARM = `${key}UPDATE_DEFAULT_ALARM`;

exports.ALARMS_FIELDS_SUCCESS = `${key}ALARMS_FIELDS_SUCCESS`;
exports.ALARMS_FIELDS_LOADING = `${key}ALARMS_FIELDS_LOADING`;
exports.ALARMS_FIELDS_ERROR = `${key}ALARMS_FIELDS_ERROR`;

exports.VARIABLES_SET_MAINTENANCE_TYPES = `${key}SET_MAINTENANCE_TYPES`;
exports.VARIBLES_MAINTENANCE_TYPES_LOADING = `${key}MAINTENANCE_TYPES_LOADING`;
exports.VARIABLES_MAINTENANCE_TYPES_ERROR = `${key}MAINTENANCE_TYPES_ERROR`;
exports.VARIABLES_MAINTENANCE_TYPES_ADD = `${key}MAINTENANCE_TYPES_ADD`;
